import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { CartContext } from '../../contexts/CartContext';
import { TmAddress } from '../../tscapi/model/account';
import { AccountUtils } from '../../tscapi/utils/account-utils';

import { AddressForm } from './address.form';
import { Loading } from './loading.component';

interface AddModalProps {
    openAddModal: boolean;
    setAddModalIsOpen: (boolean) => void;
    setOpenParentModal: (boolean) => void;
}

export const AddShippingAddress = ({ openAddModal, setAddModalIsOpen, setOpenParentModal }: AddModalProps) => {
    const { t } = useTranslation();
    const { addShippingAddress, setIsLoading } = useContext(CartContext);
    const [addressErrorMessage, setErrorMessage] = useState('');
    const [formState, setFormState] = useState('');
    const [addressToAdd, setAddressToAdd] = useState<TmAddress>({
        Id: 0,
        FirstName: '',
        LastName: '',
        DayPhone: '',
        Street: '',
        AddressRef1: '',
        City: '',
        State: '',
        ZipCode: '',
        IsDefault: false,
        POBoxNumber: '',
        IsPOBox: false,
        SalesForceAddressId: '',
    });

    const closeModal = () => {
        setErrorMessage('');
        setAddModalIsOpen(false);
        setOpenParentModal(true);
    };
    const addCartShippingAddress = async () => {
        if (addressToAdd) {
            setIsLoading(true);
            const cartAddressToAdd = AccountUtils.formatAddressData(addressToAdd);
            try {
                await addShippingAddress(cartAddressToAdd);
                setAddModalIsOpen(false);
            } catch (error) {
                setErrorMessage(
                    AccountUtils.getErrorMessage(error, t('Unable to add this shipping address. Please try again.')),
                );
                setFormState('');
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (formState == 'submit') {
            addCartShippingAddress();
        }
    }, [formState]);

    const validateFormAndSubmit = () => {
        setFormState('validate');
    };

    Modal.setAppElement('#expressCheckout');
    return (
        <>
            <div>
                <Modal
                    isOpen={openAddModal}
                    contentLabel={t('Add Shipping Address')}
                    className="modal__contentwrap"
                    overlayClassName="modal__overlay"
                >
                    <div className="modal__header">
                        <button className="modal__button-back" onClick={closeModal}>
                            {t('Back')}
                        </button>
                        <h3 className="shipping__modal-text">{t('Add Shipping Address')}</h3>
                        <button className="modal__button-close" onClick={closeModal}>
                            {t('Close')}
                        </button>
                    </div>
                    <div className="modal__body">
                        {addressErrorMessage && (
                            <div className="alert alert-danger">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    className="form__error-svg"
                                >
                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
                                </svg>
                                {addressErrorMessage}
                            </div>
                        )}
                        <AddressForm
                            selectedAddress={addressToAdd}
                            setSelectedAddress={setAddressToAdd}
                            formState={formState}
                            setFormState={setFormState}
                            setErrorMessage={setErrorMessage}
                        />
                    </div>
                    <div className="modal__footer">
                        <Loading />
                        <button className="modal__button--save button" onClick={validateFormAndSubmit}>
                            {t('Save & Continue')}
                        </button>
                    </div>
                </Modal>
            </div>
        </>
    );
};
